<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="vorname{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.NATUERLICHE_PERSON.VORNAME' | translate }}</label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="vorname{{objectId}}" formControlName="vorname" id="vorname{{index}}" type="text"
             utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
    </div>
  </div>

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="nachname{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.NATUERLICHE_PERSON.NACHNAME' | translate }}</label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="nachname{{objectId}}" formControlName="nachname" id="nachname{{index}}" type="text"
             utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
    </div>
  </div>

</form>
